<template>
  <div>Hello, World!</div>
</template>

<script setup lang="ts"></script>

<style scoped></style>
